import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../../../apiconfig";
import "./alert.css";
import logoutUser from "./logoutUser";

function Centre({ onNext, onPrev }) {

	const navigate = useNavigate();
	const [selectedProgram, setSelectedProgram] = useState("");
	const [selectedCentre, setSelectedCentre] = useState("");
	const [alertData, setAlertData] = useState(null);

	const showAlert = (message, type = "error") => {
		setAlertData({
			message,
			type,
			id: Date.now()
		});

		setTimeout(() => {
			setAlertData(null);
		}, 5000);
	};

	const handleNext = async () => {

		if (!selectedCentre) {
			showAlert("Please select Centre ❗");
			return;
		}

		try {
			const token = sessionStorage.getItem("token");

			const response = await fetch(
				`${API_BASE_URL}/API/Student/SAVE_CENTRE`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						"Authorization": "Bearer " + token
					},
					body: JSON.stringify({
						centre: selectedCentre
					})
				}
			);

			// 🔐 Session expired
			/*if (response.status === 401) {
				sessionStorage.clear();

				showAlert("Session expired ❗ Please login again", "error");

				setTimeout(() => {
					window.location.href = "/ASTU_JMEE_JLEE/Login";
				}, 1000);

				return;
			}*/



			if (!response.ok) {
				throw new Error("Failed to save centre");
			}

			const result = await response.text();
			if (result === "PROGRAM_SELECTION_INCOMPLETE") {
				showAlert("Please complete Program Selection first ❗");
				return;
			}
			console.log("Response:", result);

			showAlert("Centre saved successfully ✅", "success");

			setTimeout(() => {
				onNext();
			}, 800);

		} catch (error) {
			console.error("Error:", error);
			showAlert("Something went wrong while saving centre ❗");
		}
	};

	useEffect(() => {
		const fetchProgram = async () => {
			try {
				const token = sessionStorage.getItem("token");

				const response = await fetch(
					`${API_BASE_URL}/API/Student/GET_PROGRAM`,
					{
						method: "GET",
						headers: {
							"Authorization": "Bearer " + token
						}
					}
				);

				if (!response.ok) return;

				const data = await response.text(); // since backend returns string
				console.log("selected program is:", data);

				if (data) {
					setSelectedProgram(data); // ✅ auto select
				}

			} catch (err) {
				console.error("Failed to fetch program", err);
			}
		};

		fetchProgram();
	}, []);

	useEffect(() => {
		const fetchCentre = async () => {
			try {
				const token = sessionStorage.getItem("token");

				const response = await fetch(
					`${API_BASE_URL}/API/Student/GET_CENTRE`,
					{
						method: "GET",
						headers: {
							"Authorization": "Bearer " + token
						}
					}
				);

				if (response.status === 401 || response.status === 403) {

					logoutUser(navigate);
					return;
				}

				if (!response.ok) {
					console.error("Failed to fetch program");
					return;
				}

				if (!response.ok) return;

				const data = await response.text();
				console.log("Saved centre:", data);

				// 🔥 If already saved, auto select
				if (data) {
					setSelectedCentre(data);
				}

			} catch (error) {
				console.error("Error fetching centre:", error);
			}
		};

		fetchCentre();
	}, []);

	const [isPaymentDone, setIsPaymentDone] = useState(false);

	useEffect(() => {
		const checkPaymentStatus = async () => {
			try {
				const token = sessionStorage.getItem("token");

				const response = await fetch(
					`${API_BASE_URL}/API/Student/GET_PAYMENT_DONE_OR_NOT`,
					{
						method: "GET",
						headers: {
							"Authorization": "Bearer " + token
						}
					}
				);

				if (!response.ok) return;

				const result = await response.json(); // boolean true/false
				console.log("Payment Done:", result);

				setIsPaymentDone(result);



			} catch (error) {
				console.error("Error checking payment:", error);
			}
		};

		checkPaymentStatus();
	}, []);

	const [isEditOn, setIsEditOn] = useState(false);
		   useEffect(() => {
		       const checkPaymentStatus = async () => {
		           try {
		               const token = sessionStorage.getItem("token");

		               const response = await fetch(
		                   `${API_BASE_URL}/API/Student/EDIT_ON_OFF`,
		                   {
		                       method: "GET",
		                       headers: {
		                           "Authorization": "Bearer " + token
		                       }
		                   }
		               );

		               if (!response.ok) return;

		               const result = await response.json();
		               console.log("edit response:", result);

		               setIsEditOn(result);



		           } catch (error) {
		               console.error("Error checking payment:", error);
		           }
		       };

		       checkPaymentStatus();
		   }, []);

		  // const canEdit = !isPaymentDone || isEditOn === false;
		   const canEdit = isEditOn === false;

		   
	return (
		<>
			<style>{`

		@keyframes smoothEntry {
			0% {
				opacity: 0;
				transform: translateY(20px);
			}
			100% {
				opacity: 1;
				transform: translateY(0);
			}
		}

		.program-container {
			background: #ffffff;
			padding: 20px;
			border-radius: 12px;
			border: 1px solid #e2e8f0;
			font-family: 'Poppins', sans-serif;
			width: 100%;
			max-width: 850px;
			display: flex;
			flex-direction: column;
			animation: smoothEntry 0.4s ease;
		}

		.program-title {
			font-size: 18px;
			font-weight: 600;
			color: #1e3a8a;
			margin-bottom: 15px;
		}

		.radio-group {
			display: flex;
			flex-direction: column;
			gap: 10px;
		}

		.radio-item {
			display: flex;
			align-items: center;
			gap: 12px;
			padding: 12px 14px;
			border: 1px solid #e2e8f0;
			border-radius: 8px;
			cursor: pointer;
			transition: 0.25s;
			position: relative;
		}

		.radio-item:hover {
			background: #f8fafc;
		}

		.radio-item.active {
			background: #eff6ff;
			border-left: 4px solid #2563eb;
		}

		.radio-item input {
			display: none;
		}

		.radio-item::before {
			content: "";
			width: 16px;
			height: 16px;
			border-radius: 50%;
			border: 2px solid #94a3b8;
			display: inline-block;
		}

		.radio-item.active::before {
			border: 5px solid #2563eb;
		}

		.radio-text {
			font-size: 13px;
			color: #1e293b;
			line-height: 1.4;
		}

		.footer {
			display: flex;
			justify-content: space-between;
			margin-top: 20px;
		}

		.btn {
			padding: 8px 16px;
			border-radius: 6px;
			border: none;
			cursor: pointer;
			font-size: 13px;
		}

		.prev-btn {
			background: #e2e8f0;
		}

		.next-btn {
			background: #2563eb;
			color: white;
		}

		.next-btn:disabled {
			background: #94a3b8;
			cursor: not-allowed;
		}
		.program-subtitle {
			font-size: 13px;
			color: #475569;
			margin-bottom: 12px;
		}
		/* 📱 Mobile Responsive */
		@media (max-width: 768px) {

			.program-container {
				padding: 15px;
				border-radius: 10px;
				max-width: 100%;
			}

			.program-title {
				font-size: 16px;
				text-align: center;
			}

			.program-subtitle {
				font-size: 12px;
				text-align: center;
			}

			.radio-group {
				gap: 8px;
			}

			.radio-item {
				padding: 10px;
				border-radius: 6px;
			}

			.radio-text {
				font-size: 12px;
			}

			/* Footer buttons stack */
			.footer {
				flex-direction: column;
				gap: 10px;
			}

			.btn {
				width: 100%;
				padding: 10px;
				font-size: 14px;
			}

			.prev-btn, .next-btn {
				width: 100%;
			}
		}

		/* 📱 Extra small devices */
		@media (max-width: 480px) {

			.program-container {
				padding: 12px;
			}

			.program-title {
				font-size: 15px;
			}

			.radio-item {
				padding: 8px;
			}

			.radio-text {
				font-size: 11.5px;
			}

			.radio-item::before {
				width: 14px;
				height: 14px;
			}

			.radio-item.active::before {
				border: 4px solid #2563eb;
			}
		}
		.radio-item input:disabled + .radio-text {
		  opacity: 0.5;
		  filter: grayscale(100%);
		  cursor: not-allowed;
		}

		/* Also blur the whole row */
		.radio-item:has(input:disabled) {
		  opacity: 0.5;
		  filter: grayscale(100%);
		  cursor: not-allowed;
		  pointer-events: none; /* prevent click */
		}

		`}</style>

			{/* Alert */}
			{alertData && (
				<div className={`custom-alert ${alertData.type}`}>
					<span className="alert-icon">
						{alertData.type === "success" ? "✔" : "❗"}
					</span>
					{alertData.message}
				</div>
			)}

			<div className="program-container">
				<div className="program-title">Centre Selection</div>

				{selectedProgram && (
					<div className="program-subtitle">
						Exam centre for : <b>{selectedProgram}</b>
					</div>
				)}

				<div className="radio-group">

					<label className={`radio-item ${selectedCentre === "GUWAHATI" ? "active" : ""}`}>
						<input
							type="radio"
							name="centre"
							value="GUWAHATI"
							checked={selectedCentre === "GUWAHATI"}
							onChange={(e) => setSelectedCentre(e.target.value)}
							disabled={isPaymentDone || !canEdit}
						/>
						<div className="radio-text">
							Guwahati
						</div>
					</label>

					<label className={`radio-item ${selectedCentre === "JORHAT" ? "active" : ""}`}>
						<input
							type="radio"
							name="centre"
							value="JORHAT"
							checked={selectedCentre === "JORHAT"}
							onChange={(e) => setSelectedCentre(e.target.value)}
							disabled={isPaymentDone || !canEdit}
						/>
						<div className="radio-text">
							Jorhat
						</div>
					</label>

				</div>

				{/* Footer */}
				<div className="footer">

					<button className="btn prev-btn" onClick={onPrev}>
						⬅ Previous
					</button>

					<button
						className="btn next-btn"
						disabled={!selectedCentre}
						onClick={handleNext}
					>
						Next ➜
					</button>

				</div>
			</div>
		</>
	);
}

export default Centre;